import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'createStream';
export const useCreateStreamTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавить источник',
    on_success: 'Источник создан',
    on_error: 'Не удалось создать источник',
    create_stream_form: {
      title: 'Новый источник',
      name: 'Название',
      type: 'Тип',
      reference: 'Полный путь к потоку',
      group: 'Группа',
      analytics: 'Видеоаналитики',
      analytics_add: 'Добавить',
      analytics_inherited_toast: 'Список видеоаналитик и их настройки наследуются от группы. Внести изменения вы сможете после создания в настройках источника.',
      analytics_empty_toast: 'Добавьте хотя бы одну видеоаналитику',
      new_analytics: {
        title: 'Новая видеоаналитика',
        type: 'Тип',
        handler: 'ID обработчика для лучших кадров',
        on_add: 'Добавить',
        on_cancel: 'Отмена',
        validation: {
          required: 'Заполните обязательные поля',
          uuid: 'Введите корректный UUID',
        },
      },
      on_cancel: 'Отмена',
      on_submit: 'Создать',
      stream_type_stream: 'Видеопоток',
      stream_type_videofile: 'Видеофайл',
      validation: {
        required: 'Заполните обязательные поля',
        name_pattern: 'Допустимы латинские буквы, цифры, «-» и «_»',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add source',
    on_success: 'Source created',
    on_error: 'Failed to create source',
    create_stream_form: {
      title: 'New source',
      name: 'Name',
      type: 'Type',
      reference: 'Full path to the stream',
      group: 'Group',
      analytics: 'Video analytics',
      analytics_add: 'Add',
      analytics_inherited_toast: 'The list of video analytics and their settings is inherited from the group. You will be able to make changes after creation in the source settings.',
      analytics_empty_toast: 'Add at least one video analytics',
      new_analytics: {
        title: 'New video analytics',
        type: 'Type',
        handler: 'Handler ID for best frames',
        on_add: 'Add',
        on_cancel: 'Cancel',
        validation: {
          required: 'Fill in the required fields',
          uuid: 'Enter a valid UUID',
        },
      },
      on_cancel: 'Cancel',
      on_submit: 'Create',
      stream_type_stream: 'Video stream',
      stream_type_videofile: 'Video file',
      validation: {
        required: 'Fill in the required fields',
        name_pattern: 'Only latin letters, digits, «-» and «_» are allowed',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Añadir fuente',
    on_success: 'Fuente creada',
    on_error: 'No se pudo crear la fuente',
    create_stream_form: {
      title: 'Nueva fuente',
      name: 'Nombre',
      type: 'Tipo',
      reference: 'Ruta completa al flujo',
      group: 'Grupo',
      analytics: 'Videoanalíticas',
      analytics_add: 'Añadir',
      analytics_inherited_toast: 'La lista de videoanalíticas y sus ajustes se hereda del grupo. Podrá realizar cambios después de la creación en los ajustes de la fuente.',
      analytics_empty_toast: 'Añada al menos una videoanalítica',
      new_analytics: {
        title: 'Nueva videoanalítica',
        type: 'Tipo',
        handler: 'ID del procesador para mejores fotogramas',
        on_add: 'Añadir',
        on_cancel: 'Cancelar',
        validation: {
          required: 'Complete los campos obligatorios',
          uuid: 'Introduzca un UUID válido',
        },
      },
      on_cancel: 'Cancelar',
      on_submit: 'Crear',
      stream_type_stream: 'Flujo de vídeo',
      stream_type_videofile: 'Archivo de video',
      validation: {
        required: 'Complete los campos obligatorios',
        name_pattern: 'Solo letras latinas, dígitos, «-» y «_»',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar fonte',
    on_success: 'Fonte criada',
    on_error: 'Falha ao criar fonte',
    create_stream_form: {
      title: 'Nova fonte',
      name: 'Nome',
      type: 'Tipo',
      reference: 'Caminho completo para o fluxo',
      group: 'Grupo',
      analytics: 'Videoanalíticas',
      analytics_add: 'Adicionar',
      analytics_inherited_toast: 'A lista de videoanalíticas e suas configurações é herdada do grupo. Você poderá fazer alterações após a criação nas configurações da fonte.',
      analytics_empty_toast: 'Adicione pelo menos uma videoanalítica',
      new_analytics: {
        title: 'Nova videoanalítica',
        type: 'Tipo',
        handler: 'ID do processador para melhores quadros',
        on_add: 'Adicionar',
        on_cancel: 'Cancelar',
        validation: {
          required: 'Preencha os campos obrigatórios',
          uuid: 'Insira um UUID válido',
        },
      },
      on_cancel: 'Cancelar',
      on_submit: 'Criar',
      stream_type_stream: 'Fluxo de vídeo',
      stream_type_videofile: 'Arquivo de vídeo',
      validation: {
        required: 'Preencha os campos obrigatórios',
        name_pattern: 'Apenas letras latinas, dígitos, «-» e «_»',
      },
    },
  },
}) : {}) as Record<string, unknown>;
